import Todo from "./todo";
import MyCats from "./my_cats";

function Dashboard() {
  return (
    <div className="p-4 flex flex-col gap-4">
      <Todo />
      <MyCats />
    </div>
  );
}

export default Dashboard;
